// extracted by mini-css-extract-plugin
module.exports =  {"delay":"FKQ3d8pfBU7J8XAUoNiD","delayElement":"rdGQerTU3b7AG4oFtZKw","timeOfDaySelect":"QddsG1qGlEUrF2NfpT3V"};